var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconObjetivosConhecimento(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 10,
    fill: "#FF0080"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.8125 14.375H29.375V16.25H22.8125V14.375ZM22.8125 19.0625H29.375V20.9375H22.8125V19.0625ZM22.8125 23.75H29.375V25.625H22.8125V23.75ZM10.625 14.375H17.1875V16.25H10.625V14.375ZM10.625 19.0625H17.1875V20.9375H10.625V19.0625ZM10.625 23.75H17.1875V25.625H10.625V23.75Z",
    fill: "#F8F8F8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.25 9.6875H8.75C8.25272 9.6875 7.77581 9.88504 7.42417 10.2367C7.07254 10.5883 6.875 11.0652 6.875 11.5625V28.4375C6.875 28.9348 7.07254 29.4117 7.42417 29.7633C7.77581 30.115 8.25272 30.3125 8.75 30.3125H31.25C31.7473 30.3125 32.2242 30.115 32.5758 29.7633C32.9275 29.4117 33.125 28.9348 33.125 28.4375V11.5625C33.125 11.0652 32.9275 10.5883 32.5758 10.2367C32.2242 9.88504 31.7473 9.6875 31.25 9.6875ZM8.75 11.5625H19.0625V28.4375H8.75V11.5625ZM20.9375 28.4375V11.5625H31.25V28.4375H20.9375Z",
    fill: "#F8F8F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconObjetivosConhecimento);
export default __webpack_public_path__ + "static/media/icon-objetivos-conhecimento.c7d94efb703ee5275a82b34d1db73924.svg";
export { ForwardRef as ReactComponent };